// VerifyEmail.jsx
// Modern email verification page with professional design

import React from 'react';
import { styles } from './styles';
import useEmailVerification from './useEmailVerification';
import VerificationStatus from './VerificationStatus';

const VerifyEmail = () => {
  const {
    status,
    errorMsg,
    retryVerification,
    resendEmail,
    goToLogin
  } = useEmailVerification();

  const shouldShowHelpText = status !== 'success' && status !== 'ready' && status !== 'applying';
  const isSuccess = status === 'success' || status === 'alreadyVerified';

  return (
    <div style={styles.container}>
      {/* Background decoration */}
      <div style={styles.backgroundDecoration}></div>
      
      <div style={styles.card}>
        {/* Header with icon */}
        <div style={styles.header}>
          <div style={styles.iconContainer}>
            {isSuccess ? (
              <div style={styles.successIcon}>✓</div>
            ) : (
              <div style={styles.logoIcon}>
                <img 
                  src="/favicon_io/android-chrome-192x192.png" 
                  alt="Redbird Markets Logo" 
                  style={styles.logoImage}
                />
              </div>
            )}
          </div>
          <h1 style={styles.title}>Email Verification</h1>
          {!isSuccess && (
            <p style={styles.subtitle}>Verifying your Illinois State University email address</p>
          )}
        </div>
        
        <VerificationStatus
          status={status}
          errorMsg={errorMsg}
          onRetry={retryVerification}
          onResend={resendEmail}
          onGoToLogin={goToLogin}
        />
      </div>
    </div>
  );
};

export default VerifyEmail;